import React from "react";

import { Container } from "@chakra-ui/react";
import BreadNav from "modules/shared/components/BreadNav/BreadNav";
import GraphsList from "modules/monitoring/Graphs/components/GraphsList";

export default function Graphs() {
  return (
    <Container>
      <BreadNav />
      <GraphsList />
    </Container>
  );
}
